import Glightbox, { GlightboxInstance } from 'glightbox';
import 'glightbox/dist/css/glightbox.css';

class Lightbox {
  public constructor(className: string) {
    this.className = className;
  }

  private readonly className: string;

  private lightbox: GlightboxInstance;

  public readonly init = (): void => {
    this.lightbox = Glightbox({ selector: `.${this.className}` });
  };

  public readonly unset = (): void => {
    if (this.lightbox) {
      this.lightbox.destroy();
    }
  };
}

export default Lightbox;
